<template>
	<div class="choice-render">
		<div class="subject-info">
      <div class="subject-title" style="font-size: 1.5rem">题目编号: {{ problemInfo.number }}</div>
			<!-- 题目 -->
			<div class="subject-title">
				<img class="subject-type"
					:src="require('@/assets/img/preliminaryClassic/'+(subjectInfo.is_multiple=='0'?'radio':'multiple')+'.png')">
				<pre class="katex-con" v-html="markedText(subjectInfo.description)"></pre>
			</div>
			<!-- 选项 -->
			<div class="answer-list">
				<el-row :gutter="50" v-for="(a, i) in optionRow" :key="i">
					<el-col :span="12" v-for="(b, j) in 2" :key="i+'-'+j">
						<template v-if="2*i+j < Object.keys(subjectInfo.option).length">
							<div class="answer-item" :class="judgingRightOrWrong(optionKey[2*i+j])"
								@click="optionSelected(optionKey[2*i+j])">
								<div class="selection-box" :class="subjectInfo.is_multiple=='0'?'select-radio':'select-checkbox'">
									<!-- 单选与多选选中 -->
									<span v-if="subjectInfo.is_multiple=='0'" class="radio-box"></span>
									<span v-if="subjectInfo.is_multiple!='0'" class="iconfont icon-dui"></span>
									<!-- 回看对与错图标 -->
									<span class="iconfont icon-gou"></span>
									<span class="iconfont icon-X"></span>
								</div>
								<!-- 选项内容 -->
								<pre ref="subjectName" class="katex-con"
									v-html="markedText(optionKey[2*i+j]+'：'+subjectInfo.option[optionKey[2*i+j]])"></pre>
							</div>
						</template>
					</el-col>
				</el-row>
			</div>
		</div>
	</div>
</template>

<script>
	import marked from 'marked';
	import {
		objIsPro
	} from "@/utils/validate"
	export default {
		name: "ChoiceRender",
		components: {},
		props: {
			problemInfo: {
				type: Object,
				default: null
			},
			userResult: {
				type: Object,
				default: null
			},
			isLookingBack: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				optionKey: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
				subjectInfo: this.problemInfo,
				triggerComputed: false
			}
		},
		created() {
			if (!this.subjectInfo.choice) {
				this.subjectInfo["choice"] = []; // 添加勾选答案的属性，默认空
			}
			if (this.userResult.result) {
				this.subjectInfo["userAnswer"] = this.userResult.result.userAnswer;
				this.subjectInfo["choice"] = this.userResult.result.userAnswer;
			}
		},
		destroyed() {},
		mounted() {},
		watch: {
			problemInfo(newVal) {
				if (!newVal.choice) {
					newVal["choice"] = []; // 添加勾选答案的属性，默认空
				}
				this.subjectInfo = JSON.parse(JSON.stringify(newVal));
				this.setKatex();
			},
			userResult(newVal) {
				if (newVal.result) {
					this.subjectInfo["userAnswer"] = newVal.result.userAnswer;
					this.subjectInfo["choice"] = newVal.result.userAnswer;
				}
			}
		},
		filters: {},
		computed: {
			optionRow() {
				return Math.ceil(Object.keys(this.subjectInfo.option).length / 2);
			},
			judgingRightOrWrong() {
				return (item) => {
					let triggerComputed = this.triggerComputed;
					let choice = this.subjectInfo.choice; // 做题选择的答案
					if (!this.isLookingBack) {
						if (choice && choice.includes(item)) return "answer-gou"
					} else {
						let correct = this.subjectInfo.correct; // 是否正确
						let correctAnswer = this.subjectInfo.correct_answer; // 正确答案
						if (correct && correctAnswer.includes(item)) {
							return "answer-dui answer-border answer-gou"
						} else if (!correct && correctAnswer.includes(item) && choice.includes(item)) {
							return "answer-dui answer-border answer-gou"
						} else if (!correct && correctAnswer.includes(item) && !choice.includes(item)) {
							return "answer-dui"
						} else if (!correct && !correctAnswer.includes(item) && choice.includes(item)) {
							return "answer-cuo answer-border answer-gou"
						}
					}
				}
			},
			markedText() {
				return (text) => {
					return marked.parse(text, {
						mangle: false,
						headerIds: false,
						gfm: true, //允许 Git Hub标准的markdown
						breaks: true, //允许回车换行（该选项要求 gfm 为true）
						sanitize: false, //对输出进行过滤（清理），将忽略任何已经输入的html代码（标签
					});
				}
			},
		},
		methods: {
			setKatex() { // 设置题目或选项中的计算公式
				let times = setInterval(_ => {
					let katexDom = document.getElementsByClassName("katex-con");
					if (katexDom.length != 0) {
						clearInterval(times);
						for (var i = 0; i < katexDom.length; i++) {
							this.$formula(katexDom[i])
						}
					}
				}, 10)
			},
			optionSelected(option) { // 选中选项
				if (this.isLookingBack) return; // 回看禁止选择
				let subInfo = this.subjectInfo;
				if (subInfo["choice"].includes(option)) {
					subInfo["choice"] = subInfo["choice"].filter(a => a != option);
				} else {
					if (subInfo.is_multiple == '0') subInfo["choice"] = [option]
					else subInfo["choice"].push(option)
				}
				this.triggerComputed = !this.triggerComputed
			},
			submitCode() { // 提交选项
				if (this.subjectInfo.choice.length) {
					const data = {
						answer: this.subjectInfo.choice
					}
					this.$emit('commitResult', data);
				} else {
					this.$message.warning("请勾选选项后再提交")
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.choice-render {
		padding: 0 4.8rem;
		// overflow-y: auto;

		.subject-title {
			position: relative;
			margin: 2.5rem 0 2rem;
			user-select: none;

			.subject-type {
				position: absolute;
				width: 5rem;
				height: 3.6rem;
				top: 0;
				left: 0;
			}

			pre {
				min-height: 6rem;
				justify-content: center;
				font-size: 1.6rem;
				line-height: 2.1rem;
				padding: 1.6rem 2.4rem;
				background-color: rgba(29, 78, 100, 0.8);
				border-radius: 0.32rem;
				white-space: inherit;
				user-select: none;

				::v-deep p>code {
					display: initial;
				}

				::v-deep code {
					background: #0A3446;
					color: #9ef2ff;
					border-radius: 0.4rem;
					padding: 0.1rem 0.6rem;
				}

				::v-deep a {
					pointer-events: none;
					color: #FFF;
				}
			}
		}

		.answer-list {
			.answer-item {
				margin-bottom: 1.6rem;
				cursor: pointer;
				position: relative;
				border-radius: 0.32rem;

				pre {
					padding: 1rem 1.2rem 1rem 3.5rem;
					background-color: rgba(29, 78, 100, 0.8);
					border-radius: 0.32rem;
					font-size: 1.2rem;
					white-space: inherit;
					user-select: none;
          display: flex;

					::v-deep p {
            line-height: 1;
						img {
							max-width: 100%;
						}

						a {
							pointer-events: none;
							color: #FFF;
						}

						code {
							display: inline;
							background: none;
							border-radius: 0.16rem;
							white-space: initial;
							color: #FFF;
							padding: 0;
						}
					}
				}

				.selection-box {
					width: 0.88rem;
					height: 0.88rem;
					border: 2px solid #26D1DF;
					position: absolute;
					left: 1.2rem;
					top: 50%;
					transform: translate(0, -50%);
				}

				.radio-box {
					background-color: #26D1DF;
					border-radius: 50%;
					width: 0.6rem;
					height: 0.6rem;
					position: absolute;
					top: calc(50% - 0.3rem);
					left: calc(50% - 0.3rem);
					display: none;
				}

				.icon-dui {
					color: #26D1DF;
					font-size: 1.1rem;
					position: absolute;
					left: -2px;
					top: -2px;
					display: none;
				}

				.icon-gou {
					color: #00FF0C;
					position: absolute;
					font-size: 1.4rem;
					top: -0.4rem;
					left: -0.08rem;
					display: none;
				}

				.icon-X {
					color: #F60000;
					position: absolute;
					font-size: 1.6rem;
					top: -0.3rem;
					left: -0.3rem;
					display: none;
				}

				.selection-box.select-radio {
					border-radius: 50%;
				}
			}

			.answer-gou {
				background-color: #1C93AD;

				.radio-box,
				.icon-dui {
					display: inline-block;
				}
			}

			.answer-dui {
				background-color: rgba(15, 149, 211, 1);

				.icon-gou {
					display: inline-block;
				}
			}

			.answer-cuo {
				background-color: rgba(28, 147, 173, 0.8);

				.icon-X {
					display: inline-block;
				}
			}

			.answer-border {
				box-shadow: 0 0 0 2px #41f1ff;
			}

			.answer-gou,
			.answer-dui,
			.answer-cuo {
				pre {
					background-color: rgba(0, 0, 0, 0);
				}
			}
		}
	}
</style>
